import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon, SearchIcon } from 'lucide-react';
import { ViewToggle } from '../components/MyApps/ViewToggle';
import { AppTileView } from '../components/MyApps/AppTileView';
import { AppCardView } from '../components/MyApps/AppCardView';
import { AppListView } from '../components/MyApps/AppListView';
import { TabInterface } from '../components/MyApps/TabInterface';
import { CreateAppButton } from '../components/MyApps/CreateAppButton';
import { useNavigate } from 'react-router-dom';
import { useAppSettings } from '../context/AppSettingsContext';
type ViewMode = 'tiles' | 'cards' | 'list';
export const MyApps = () => {
  const {
    viewMode,
    setViewMode
  } = useAppSettings();
  const [isCustomizing, setIsCustomizing] = useState(false);
  const [showCreated, setShowCreated] = useState(true);
  const [showLibrary, setShowLibrary] = useState(true);
  const [openTabs, setOpenTabs] = useState<string[]>([]);
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const navigate = useNavigate();
  const renderAppsView = () => {
    const createAppTile = {
      id: 'create-new',
      title: 'Create New App',
      icon: 'plus',
      iconBg: 'bg-indigo-500',
      onClick: () => navigate('/create')
    };
    switch (viewMode) {
      case 'tiles':
        return <AppTileView onOpenApp={handleOpenApp} createAppTile={createAppTile} data-id="element-2184" />;
      case 'list':
        return <AppListView onOpenApp={handleOpenApp} createAppTile={createAppTile} data-id="element-2185" />;
      default:
        return <AppCardView onOpenApp={handleOpenApp} createAppTile={createAppTile} data-id="element-2186" />;
    }
  };
  const handleOpenApp = (appId: string) => {
    if (!openTabs.includes(appId)) {
      setOpenTabs([...openTabs, appId]);
    }
    setActiveTab(appId);
  };
  return <div className="flex flex-col h-full" data-id="element-2187">
      {openTabs.length > 0 && <TabInterface tabs={openTabs} activeTab={activeTab} onTabChange={setActiveTab} onTabClose={tabId => {
      setOpenTabs(openTabs.filter(id => id !== tabId));
      if (activeTab === tabId) {
        setActiveTab(openTabs[0] || null);
      }
    }} onCloseAll={() => {
      setOpenTabs([]);
      setActiveTab(null);
    }} data-id="element-2188" />}
      {!activeTab && <div className="p-6" data-id="element-2189">
          {/* Created Apps Section */}
          <div className="mb-8" data-id="element-2190">
            <div className="flex items-center justify-between mb-4" data-id="element-2191">
              <button onClick={() => setShowCreated(!showCreated)} className="flex items-start group" data-id="element-2192">
                <div className="pt-1.5 pr-2" data-id="element-2193">
                  {showCreated ? <ChevronDownIcon className="h-4 w-4 text-gray-400 group-hover:text-gray-600" data-id="element-2194" /> : <ChevronRightIcon className="h-4 w-4 text-gray-400 group-hover:text-gray-600" data-id="element-2195" />}
                </div>
                <div className="text-left" data-id="element-2196">
                  <h2 className="text-lg md:text-xl font-semibold" data-id="element-2197">
                    My Created Apps
                  </h2>
                  <p className="text-sm text-gray-500 md:block hidden" data-id="element-2198">
                    Create and manage your AI apps
                  </p>
                </div>
              </button>
              <ViewToggle current={viewMode} onChange={setViewMode} onCustomizeClick={() => setIsCustomizing(!isCustomizing)} isCustomizing={isCustomizing} data-id="element-2199" />
            </div>
            {showCreated && <div className="grid grid-cols-1 gap-6" data-id="element-2200">{renderAppsView()}</div>}
          </div>
          {/* App Library Section */}
          <div data-id="element-2201">
            <div className="flex items-center justify-between mb-4" data-id="element-2202">
              <button onClick={() => setShowLibrary(!showLibrary)} className="flex items-start group" data-id="element-2203">
                <div className="pt-1.5 pr-2" data-id="element-2204">
                  {showLibrary ? <ChevronDownIcon className="h-4 w-4 text-gray-400 group-hover:text-gray-600" data-id="element-2205" /> : <ChevronRightIcon className="h-4 w-4 text-gray-400 group-hover:text-gray-600" data-id="element-2206" />}
                </div>
                <div className="text-left" data-id="element-2207">
                  <h2 className="text-lg md:text-xl font-semibold" data-id="element-2208">
                    App Library
                  </h2>
                  <p className="text-sm text-gray-500 md:block hidden" data-id="element-2209">
                    Your installed AI apps
                  </p>
                </div>
              </button>
              <div className="relative hidden md:block" data-id="element-2210">
                <input type="text" placeholder="Search library..." className="pl-10 pr-4 py-2 border rounded-md" data-id="element-2211" />
                <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2212" />
              </div>
            </div>
            {showLibrary && <div className="grid grid-cols-1 gap-6" data-id="element-2213">{renderAppsView()}</div>}
          </div>
        </div>}
    </div>;
};